import React, { useState, useEffect } from "react";

// Jednoduchá kniha jázd - načítanie a uloženie jázd podľa ŠPZ
function KnihaJazd() {
  const [spz, setSpz] = useState("");
  const [jazdy, setJazdy] = useState([]);
  const [novyZaznam, setNovyZaznam] = useState({ datum: "", odkial: "", kam: "", ucel: "", km: "" });
  const [stav, setStav] = useState("");

  // Načítať jazdy pre zadanú ŠPZ
  const nacitajJazdy = async () => {
    if (!spz) return;
    setStav("Načítavam...");
    try {
      const r = await fetch(`/php/jazdy_api.php?action=load&spz=${encodeURIComponent(spz)}`);
      const data = await r.json();
      setJazdy(Array.isArray(data) ? data : []);
      setStav("");
    } catch (e) {
      setStav("Chyba pri načítaní");
    }
  };

  // Uložiť jazdy pre ŠPZ
  const ulozJazdy = async () => {
    setStav("Ukladám...");
    try {
      await fetch(`/php/jazdy_api.php?action=save&spz=${encodeURIComponent(spz)}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tasks: jazdy })
      });
      setStav("Uložené");
    } catch (e) {
      setStav("Chyba pri ukladaní");
    }
  };

  // Pridať nový záznam
  const pridajZaznam = () => {
    if (!novyZaznam.datum || !novyZaznam.odkial || !novyZaznam.kam) return;
    setJazdy([...jazdy, { ...novyZaznam }]);
    setNovyZaznam({ datum: "", odkial: "", kam: "", ucel: "", km: "" });
  };

  return (
    <div style={{ maxWidth: 600, margin: "2em auto", padding: 20, border: "1px solid #ccc", borderRadius: 8 }}>
      <h2>Kniha jázd</h2>
      <div style={{ marginBottom: 10 }}>
        ŠPZ: <input value={spz} onChange={e => setSpz(e.target.value)} style={{ width: 120 }} />
        <button onClick={nacitajJazdy} style={{ marginLeft: 8 }}>Načítať</button>
      </div>
      <table style={{ width: "100%", marginBottom: 10, borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th>Dátum</th><th>Odkiaľ</th><th>Kam</th><th>Účel</th><th>Km</th>
          </tr>
        </thead>
        <tbody>
          {jazdy.map((j, i) => (
            <tr key={i}>
              <td><input value={j.datum} onChange={e => {
                const nj = [...jazdy]; nj[i].datum = e.target.value; setJazdy(nj);
              }} style={{ width: 90 }} /></td>
              <td><input value={j.odkial} onChange={e => {
                const nj = [...jazdy]; nj[i].odkial = e.target.value; setJazdy(nj);
              }} style={{ width: 90 }} /></td>
              <td><input value={j.kam} onChange={e => {
                const nj = [...jazdy]; nj[i].kam = e.target.value; setJazdy(nj);
              }} style={{ width: 90 }} /></td>
              <td><input value={j.ucel} onChange={e => {
                const nj = [...jazdy]; nj[i].ucel = e.target.value; setJazdy(nj);
              }} style={{ width: 90 }} /></td>
              <td><input value={j.km} onChange={e => {
                const nj = [...jazdy]; nj[i].km = e.target.value; setJazdy(nj);
              }} style={{ width: 60 }} /></td>
              <td><button onClick={() => { setJazdy(jazdy.filter((_, idx) => idx !== i)); }}>X</button></td>
            </tr>
          ))}
          <tr>
            <td><input value={novyZaznam.datum} onChange={e => setNovyZaznam({ ...novyZaznam, datum: e.target.value })} style={{ width: 90 }} /></td>
            <td><input value={novyZaznam.odkial} onChange={e => setNovyZaznam({ ...novyZaznam, odkial: e.target.value })} style={{ width: 90 }} /></td>
            <td><input value={novyZaznam.kam} onChange={e => setNovyZaznam({ ...novyZaznam, kam: e.target.value })} style={{ width: 90 }} /></td>
            <td><input value={novyZaznam.ucel} onChange={e => setNovyZaznam({ ...novyZaznam, ucel: e.target.value })} style={{ width: 90 }} /></td>
            <td><input value={novyZaznam.km} onChange={e => setNovyZaznam({ ...novyZaznam, km: e.target.value })} style={{ width: 60 }} /></td>
            <td><button onClick={pridajZaznam}>Pridať</button></td>
          </tr>
        </tbody>
      </table>
      <button onClick={ulozJazdy} style={{ marginRight: 8 }}>Uložiť všetko</button>
      {stav && <span>{stav}</span>}
    </div>
  );
}

export default KnihaJazd;
